<template>
  <StatCard
    title="Longest open"
    subtitle="Oldest unfinished work first. Usually the list of what you have been avoiding."
    :loading="loading"
    :empty="!loading && !rows.length"
    as-of-now
    empty-title="Nothing outstanding"
    :height="280"
  >
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 border-b border-gray-100 dark:border-gray-700">
            <th class="px-5 py-2.5 font-semibold">Task</th>
            <th class="px-3 py-2.5 font-semibold whitespace-nowrap">Age</th>
            <th class="px-3 py-2.5 font-semibold">Priority</th>
            <th class="px-5 py-2.5 font-semibold whitespace-nowrap">Due</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
          <tr
            v-for="row in rows" :key="row.id"
            @click="open(row)"
            class="cursor-pointer transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.03]"
          >
            <td class="px-5 py-2.5 min-w-0">
              <span class="flex items-center gap-2 min-w-0">
                <span class="w-1.5 h-1.5 rounded-full flex-shrink-0" :style="{ backgroundColor: row.color_css_code }"></span>
                <span class="truncate text-gray-800 dark:text-gray-100">{{ row.title }}</span>
              </span>
            </td>
            <td class="px-3 py-2.5 whitespace-nowrap tabular-nums text-gray-500 dark:text-gray-400">{{ ageLabel(row) }}</td>
            <td class="px-3 py-2.5">
              <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[11px] font-semibold" :class="priorityClass(row.priority)">
                {{ row.priority }}
              </span>
            </td>
            <td class="px-5 py-2.5 whitespace-nowrap text-[13px]" :class="row.is_overdue ? 'text-red-600 dark:text-red-400 font-medium' : 'text-gray-500 dark:text-gray-400'">
              {{ dueLabel(row) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </StatCard>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import StatCard from './StatCard.vue'
import { useTaskDates } from 'composables/useTaskDates.js'
import { PRIORITY_META } from '../taskPriorities.js'

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

const router = useRouter()
const { formatDueDateLabel } = useTaskDates()

function open(row) { router.push(`/tasks/${row.id}`) }

function ageLabel(row) {
  if (row.age_days < 1) return 'today'
  if (row.age_days === 1) return '1 day'
  return `${row.age_days} days`
}

function dueLabel(row) {
  if (!row.due_at) return 'No date'
  return row.is_overdue ? `Overdue, ${formatDueDateLabel(row.due_at)}` : formatDueDateLabel(row.due_at)
}

function priorityClass(priority) {
  return PRIORITY_META[priority]?.pill || PRIORITY_META.medium.pill
}

const rows = computed(() => props.rows)
</script>
